(function () {
  document.querySelectorAll('[data-hiw-poster]').forEach(function (poster) {
    if (poster.dataset.initialized) return;
    poster.dataset.initialized = 'true';
    var player = document.getElementById(poster.getAttribute('aria-controls'));
    if (!player) return;
    poster.addEventListener('click', function () {
      var source = new URL(player.dataset.hiwEmbedBase);
      source.searchParams.set('autoplay', '1');
      player.src = source.href;
      player.removeAttribute('tabindex');
      poster.hidden = true;
      player.focus({ preventScroll: true });
    });
  });
})();
